<template>
  <PlaceholderPantalla
    titulo="Historial de Ventas"
    subtitulo="Consulta y análisis de ventas realizadas"
    descripcion="Consulta el historial completo de todas las ventas realizadas con filtros avanzados por fecha, producto, cajero, método de pago. Reimprime tickets, consulta detalles de cada venta, analiza tendencias, identifica productos más vendidos, y exporta reportes para análisis financiero."
    :funcionalidades="funcionalidades"
    :datos-manejados="datosManejados"
    :mostrar-mockup="true"
  />
</template>

<script setup>
import PlaceholderPantalla from '../../Finanzas/PlaceholderPantalla.vue'

const funcionalidades = [
  'Historial completo de ventas con paginación',
  'Filtrar por rango de fechas',
  'Filtrar por producto vendido',
  'Filtrar por método de pago',
  'Filtrar por cajero/usuario',
  'Filtrar por estado (Pagada, Cancelada)',
  'Buscar por número de ticket',
  'Ver detalle completo de cada venta',
  'Reimpresión de tickets históricos',
  'Cancelación de ventas con autorización (genera nota de crédito)',
  'Análisis de ventas por hora del día',
  'Análisis de ventas por día de la semana',
  'Productos más vendidos del período',
  'Ticket promedio',
  'Exportar ventas a Excel/PDF',
  'Dashboard de ventas con gráficas'
]

const datosManejados = [
  'Número de ticket',
  'Fecha y hora de venta',
  'Mesa/Cliente',
  'Productos vendidos',
  'Cantidad y precios',
  'Subtotal, descuentos, total',
  'Método de pago',
  'Propina',
  'Estado de la venta',
  'Cajero que atendió',
  'Notas de la venta',
  'Productos cancelados (si hubo)',
  'Tiempo de servicio',
  'Ticket impreso',
  'Razón de cancelación (si aplica)',
  'Usuario que canceló (si aplica)'
]
</script>
